import { isEmpty } from "lodash-es";
import { fetchCurrency } from "./currencyAction";

export function getAccess(accessToken){
    return async function (dispatch){
        console.log("FIRED ACTION GET ACCESS",accessToken)
        const list = getTokenList(accessToken)
        console.log("Get Token Lists",{list});

        let accessPages = []
        let accessWidgets = []
        let accessConfig = []
        list.map((token) => {
            if (token.type === 'Page'){
                 console.log({token});
                if (!accessPages.includes(token.name)){
                    accessPages = [...accessPages, token.name]
                }
            } else if (token.type === 'Widget'){
                if (!accessWidgets.inscludes(token.name)){
                    accessWidgets = [...accessWidgets, token.name]
                }
            } else if (token.type === 'Config'){
                if (!accessConfig.includes(token.name)){
                    accessConfig = [...accessConfig, token.name]
                }
            }
        })
        dispatch({ type: "GET_CONFIG_PAGES", payload: accessConfig })
        dispatch({ type: "GET_PAGES", payload: accessPages })
        dispatch({ type: "GET_WIDGETS", payload: accessWidgets })
        dispatch(fetchCurrency())
    }
}
function getTokenList(accessToken){
    console.log("FIRED ACTION GET TOKENS")
    const tokens = accessToken;//.split(",");
    console.log({tokens})
    let tokenList = []
    if (!isEmpty(tokens)){
        tokenList = [{id:1300, name:"Dépenses", type:"Page"}]
    }
    
    // let widgetList = [
    //     {id: 10, name: "CA", type:"Widget"}, 
    //     {id: 20, name: "StatusBox", type:"Widget"}, 
    //     {id: 30, name: "StatusPayment", type:"Widget"}, 
    //     {id: 40, name: "StatusInstall", type:"Widget"}, 
    //     {id: 50, name: "TotalProd", type:"Widget"}, 
    //     {id: 60, name: "LastDayProd", type:"Widget"}, 
    //     {id: 70, name: "LiveProd", type:"Widget"}, 
    //     {id: 80, name: "Impact", type:"Widget"}, 
    //     {id: 90, name: "TopAbo", type:"Widget"}, 
    //     {id: 100, name: "LastSales", type:"Widget"}, 
    // ] 
    let configList = [
        {id: 1, name: "stats", type:"Config"}, 
        // {id: 20, name: "abo", type:"Config"}, 
        // {id: 30, name: "users", type:"Config"}, 
        // {id: 40, name: "sms", type:"Config"}, 
    ] 
    let hasConfig = false
    tokens.forEach( token => { // 1000_Dashboard_Page
        let infos = token.split("_")
        if (infos[2] === "Config"){
            hasConfig = true
        }
        tokenList.push({
            id:infos[0],
            name:infos[1],
            type:infos[2],
        })
    })
    
    if (hasConfig) {
        tokenList.push({
            id: 5550,
            name: "Paramètres",
            type:"Page",
        })
    }

    tokenList = sortBy(tokenList, "id")  
    
    return tokenList.concat(configList)
    
}
 function sortBy (list, field) {
    list.sort((a, b) => (
        parseInt(a[field])-parseInt(b[field])
    ));
    return list
}